import { getGTMEventData } from '@tracking/components/transformer';

function meetingBookmarkFormatter({
  bookmarkInputLength, status, message, category, ...rest
}) {
  const eventName = 'add_bookmark_status';
  return getGTMEventData(eventName, eventName, {
    bookmarkInputLength, status, message, ...rest,
  }, status, bookmarkInputLength, category);
}

export default meetingBookmarkFormatter;
